module.exports = __webpack_public_path__ + "static/media/menu23.c2532112.jpg";